import { SearchPage } from '../../../widget/Pages/Pages';
import { TimetableSearchForm } from './SearchForm';
import { Heading } from '../../../base/Heading/Heading';

interface TimetableSearchPageProps {
  query: string;
  onQueryChange: (value: string) => void;
  onSearch: (event: Event) => void;
  submitError: string | null;
  loading: boolean;
  hasSubmitted: boolean;
}

export function TimetableSearchPage({
  query,
  onQueryChange,
  onSearch,
  submitError,
  loading,
  hasSubmitted,
}: TimetableSearchPageProps) {
  return (
    <SearchPage>
      <Heading as="h2" variant="lg">
        Timetables
      </Heading>
      <TimetableSearchForm
        query={query}
        onQueryChange={onQueryChange}
        onSearch={onSearch}
        submitError={submitError}
        loading={loading}
        hasSubmitted={hasSubmitted}
      />
    </SearchPage>
  );
}
